export const Deg90CCW = [-Math.PI/2, 0, 0];
export const Deg0 = [0, 0, 0];
